import * as ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettings from './bookings-display-settings-v1-bookings-display-settings-display-settings.http.js';
import * as ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettingsTypes from './bookings-display-settings-v1-bookings-display-settings-display-settings.types.js';
import * as ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettingsUniversalTypes from './bookings-display-settings-v1-bookings-display-settings-display-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getBookingsDisplaySettingsByWidget(): __PublicMethodMetaInfo<
  'GET',
  { appId: string; widgetType: string },
  ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettingsUniversalTypes.GetBookingsDisplaySettingsByWidgetRequest,
  ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettingsTypes.GetBookingsDisplaySettingsByWidgetRequest,
  ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettingsUniversalTypes.GetBookingsDisplaySettingsByWidgetResponse,
  ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettingsTypes.GetBookingsDisplaySettingsByWidgetResponse
> {
  const payload = { appId: ':appId', widgetType: ':widgetType' } as any;

  const getRequestOptions =
    ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettings.getBookingsDisplaySettingsByWidget(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/bookings-display-settings/app/{appId}/widget-type/{widgetType}',
    pathParams: { appId: 'appId', widgetType: 'widgetType' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function upsertBookingsDisplaySettings(): __PublicMethodMetaInfo<
  'POST',
  {
    bookingsDisplaySettingsAppId: string;
    bookingsDisplaySettingsWidgetType: string;
  },
  ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettingsUniversalTypes.UpsertBookingsDisplaySettingsRequest,
  ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettingsTypes.UpsertBookingsDisplaySettingsRequest,
  ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettingsUniversalTypes.UpsertBookingsDisplaySettingsResponse,
  ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettingsTypes.UpsertBookingsDisplaySettingsResponse
> {
  const payload = {
    bookingsDisplaySettings: {
      appId: ':bookingsDisplaySettingsAppId',
      widgetType: ':bookingsDisplaySettingsWidgetType',
    },
  } as any;

  const getRequestOptions =
    ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettings.upsertBookingsDisplaySettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bookings-display-settings/upsert/app/{bookingsDisplaySettings.appId}/widget-type/{bookingsDisplaySettings.widgetType}',
    pathParams: {
      bookingsDisplaySettingsAppId: 'bookingsDisplaySettingsAppId',
      bookingsDisplaySettingsWidgetType: 'bookingsDisplaySettingsWidgetType',
    },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteBookingsDisplaySettings(): __PublicMethodMetaInfo<
  'DELETE',
  { bookingsDisplaySettingsId: string },
  ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettingsUniversalTypes.DeleteBookingsDisplaySettingsRequest,
  ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettingsTypes.DeleteBookingsDisplaySettingsRequest,
  ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettingsUniversalTypes.DeleteBookingsDisplaySettingsResponse,
  ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettingsTypes.DeleteBookingsDisplaySettingsResponse
> {
  const payload = {
    bookingsDisplaySettingsId: ':bookingsDisplaySettingsId',
  } as any;

  const getRequestOptions =
    ambassadorWixBookingsDisplaySettingsV1BookingsDisplaySettings.deleteBookingsDisplaySettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/bookings-display-settings/{bookingsDisplaySettingsId}',
    pathParams: { bookingsDisplaySettingsId: 'bookingsDisplaySettingsId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  BookingsDisplaySettings as BookingsDisplaySettingsOriginal,
  BookingsDisplaySettingsWidgetSettingsOneOf as BookingsDisplaySettingsWidgetSettingsOneOfOriginal,
  WidgetType as WidgetTypeOriginal,
  WidgetTypeWithLiterals as WidgetTypeWithLiteralsOriginal,
  SidePanelView as SidePanelViewOriginal,
  NotesSection as NotesSectionOriginal,
  NotesDisplayMode as NotesDisplayModeOriginal,
  NotesDisplayModeWithLiterals as NotesDisplayModeWithLiteralsOriginal,
  PriceSection as PriceSectionOriginal,
  LocationSection as LocationSectionOriginal,
  AssignedStaffMemberSection as AssignedStaffMemberSectionOriginal,
  RequestedStaffMemberMethodSection as RequestedStaffMemberMethodSectionOriginal,
  ResourcesSection as ResourcesSectionOriginal,
  AddOnsSection as AddOnsSectionOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  GetBookingsDisplaySettingsByWidgetRequest as GetBookingsDisplaySettingsByWidgetRequestOriginal,
  GetBookingsDisplaySettingsByWidgetResponse as GetBookingsDisplaySettingsByWidgetResponseOriginal,
  UpsertBookingsDisplaySettingsRequest as UpsertBookingsDisplaySettingsRequestOriginal,
  UpsertBookingsDisplaySettingsResponse as UpsertBookingsDisplaySettingsResponseOriginal,
  DeleteBookingsDisplaySettingsRequest as DeleteBookingsDisplaySettingsRequestOriginal,
  DeleteBookingsDisplaySettingsResponse as DeleteBookingsDisplaySettingsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  UpsertBookingsDisplaySettingsApplicationErrors as UpsertBookingsDisplaySettingsApplicationErrorsOriginal,
} from './bookings-display-settings-v1-bookings-display-settings-display-settings.types.js';
